import { Component, Input, OnInit } from '@angular/core';
import { Cart, CartProduct, ProductCatalogueStoreService } from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { UserStoreService } from 'src/app/core/store/user-store.service';

@UntilDestroy()
@Component({
  selector: 'app-cart-summary-widget',
  templateUrl: './cart-summary-widget.component.html',
  styleUrls: ['./cart-summary-widget.component.scss'],
})
export class CartSummaryWidgetComponent implements OnInit {
  @Input() checkoutDisabled = false;

  accountSummary$ = this.userStore.accountSummary$;

  cart: Cart | null;
  cartTotal: number;

  constructor(private userStore: UserStoreService, private productCatalogueStore: ProductCatalogueStoreService) {}

  ngOnInit(): void {
    this.productCatalogueStore.currentCart$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((cart: Cart) => {
      // deep copy cart
      this.cart = JSON.parse(JSON.stringify(cart));

      this.cartTotal = this.productCatalogueStore.getCartTotal();
    });

    this.productCatalogueStore.getCart();
  }

  removeItem(cartProduct: CartProduct): void {
    this.productCatalogueStore.removeProductFromCart(cartProduct.productId);
  }

  clearCart() {
    this.productCatalogueStore.resetCart();
  }
}
